import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { TreeSelect } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
    RegisterOptions,
    useController,
    useFormContext,
} from "react-hook-form";
import UnForm from "../../../../../Components/Form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";
import { FechamentoSolicitacaoController } from "../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import { ListarMotivoProblemaWebController } from "../../../../../Controllers/AssistenciaTecnica/MotivoProblema/MotivoProblemasControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { AlertConfirmation } from "../../../../../Tools/SweetAlerts";

interface IFinalizarManutencaoProps {
    setShow: Dispatch<SetStateAction<boolean>>;
}
interface ITreeData {
    id?: number;
    pId?: number;
    value?: number | string;
    title?: string;
}

interface IFinalizarManutencaoFormData {
    DS_OBSERVACAO: string;
    ID_MOTIVO_PROBLEMA: number;
}

export default function FinalizarManutencao(props: IFinalizarManutencaoProps) {
    const { ID_CASO, updateAtendimento, Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const [idMotivoProblema, setIdMotivoProblema] = useState<number>();
    const { execute, loading: finalizando } = useAsyncCallback(
        async (formData: IFinalizarManutencaoFormData) => {
            await FechamentoSolicitacaoController({
                idMotivo: formData.ID_MOTIVO_PROBLEMA,
                DadosCustos: {
                    ID_CASO: ID_CASO,
                },
                DescricaoMotivo: formData.DS_OBSERVACAO,
                flClienteVisualizaistorico: true,
            }).then(() => {
                updateAtendimento();
                ReloadHistorico();
                props.setShow(false);
            });
        }
    );

    function handleFecharSolicitacao(formData: IFinalizarManutencaoFormData) {
        AlertConfirmation(
            `Categoria de Atendimento Atual: ${Atendimento?.DS_CATEGORIA_ATENDIMENTO_COMP}, prosseguir?`,
            "",
            undefined,
            { cancelButtonText: "Não", confirmButtonText: "Sim" }
        ).then((response) => {
            if (response.isConfirmed) {
                execute(formData);
            }
        });
    }

    return (
        <UnForm handleSubmit={handleFecharSolicitacao}>
            <div className="w-100 py-3">
                <label>Motivo do problema</label>
                <SelectMotivoProblema
                    setIdMotivoProblema={setIdMotivoProblema}
                    motivoProblema={idMotivoProblema}
                    name="ID_MOTIVO_PROBLEMA"
                />
            </div>
            <UnForm.Textarea
                name="DS_OBSERVACAO"
                label="Observação"
                wrapperClassName="py-3 d-block"
            />
            <UnForm.SubmitButton
                className="w-100"
                wrapperClassName="p-0 pt-3"
                color="success"
                icon={faCheck}
                loadingSize="sm"
                loading={finalizando}
                disabled={!idMotivoProblema || undefined}
            >
                Finalizar
            </UnForm.SubmitButton>
        </UnForm>
    );
}

interface ISelectMotivoProblemaProps {
    setIdMotivoProblema?: (id: number) => void;
    motivoProblema?: number;
    defaultValue?: number;
    className?: string;

    allowClear?: boolean;

    // para compatibilidade com react-hook-form
    name?: string;
    rules?: RegisterOptions;
}

function SelectMotivoProblema(props: ISelectMotivoProblemaProps) {
    const { control } = useFormContext();
    const { field } = useController({
        name: props.name ?? "fakename",
        control,
        defaultValue: props.defaultValue ?? null,
        rules: props.rules,
    });
    const { setIdMotivoProblema } = props;

    const [treeData, setTreeData] = useState<Array<ITreeData>>();

    useEffect(() => {
        ListarMotivoProblemaWebController().then((lstMotivoProblema) => {
            setTreeData(
                lstMotivoProblema.map((motivoProblema) => ({
                    id: motivoProblema.ID_MOTIVO_PROBLEMA,
                    pId: motivoProblema.ID_MOTIVO_PROBLEMA_PAI,
                    value: motivoProblema.ID_MOTIVO_PROBLEMA,
                    title: motivoProblema.DS_MOTIVO_PROBLEMA,
                    disabled: !motivoProblema.FL_ATIVO,
                }))
            );
        });
    }, []);

    return (
        <div className="custom-tree-select-container">
            <TreeSelect<number>
                treeDataSimpleMode
                onChange={(value) => {
                    setIdMotivoProblema?.(value);
                    field.onChange(value);
                }}
                value={props.motivoProblema}
                virtual={false}
                className="w-100 h-100 custom-tree-select ant-select-custom-input"
                notFoundContent={
                    <div className="text-muted text-center">
                        Não Há Motivo de Problema Registrado
                    </div>
                }
                treeData={treeData}
                //treeDefaultExpandedKeys={defaultOpenned}
            />
        </div>
    );
}
